import React from "react";
import { FormattedHTMLMessage } from "react-intl";

import { VerificationService } from "../../lib/types/types";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";

import { SingleSignOnComponent } from "../SingleSignOnComponent";

interface StepSSOProps {
  verificationService: VerificationService;
}

export const ssoMessages = {
  title: (
    <FormattedHTMLMessage
      id="step.sso.title"
      defaultMessage="Verify using your school credentials"
      tagName="h1"
    />
  ),
  subtitle: (
    <FormattedHTMLMessage
      id="step.sso.subtitle"
      defaultMessage="Please sign in to your school's web portal. It will open in a new tab."
    />
  ),
  login: <FormattedHTMLMessage id="step.sso.login" defaultMessage="Sign in to my school" />,
  cancel: <FormattedHTMLMessage id="step.sso.cancel" defaultMessage="Upload Proof of Enrollment" />,
  subtitle2: (
    <FormattedHTMLMessage id="step.sso.subtitle2" defaultMessage="Can't sign in to your school?" />
  ),
};

const StepSSOComponent = ({ verificationService }: StepSSOProps) => (
  <SingleSignOnComponent
    verificationService={verificationService}
    stepName={VerificationStepsEnum.sso}
    messages={ssoMessages}
  />
);
export { StepSSOComponent };
